import { render } from "./setSubStatoModal.vue?vue&type=template&id=0836f67a&ts=true"
import script from "./setSubStatoModal.vue?vue&type=script&lang=ts"
export * from "./setSubStatoModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__